// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { Component } from 'react'
import cn from 'classnames'
import ChecklistButton from './ChecklistButton'
import { AVAILABLE, NOT_AVAILABLE, CHECKED } from './Checklist'
import { Mutation } from 'react-apollo'
import { fetchDailyChecklist, upsertDailyChecklist } from './checklistQueries'
import withActiveStation from '../station/withActiveStation'
import moment, { Moment } from 'moment'
import type { ShiftStatus } from './types'
import type { Station } from '../station/stationTypes'
import css from './Checklist.css'
import { i18n } from '../index'
import { removeTypename } from '../../common/utils'
const dateFormat = 'YYYY-MM-DD'

/*
  - logic to lock a task check button
  - task should be able to be checked 1 hour before and after the shift
  Morning shift:    6 -> 14
  Afternoon shift:  14 - 22
  Evening shift:    22 - 6
*/
const isLocked = (chosenDate: string, currentTime: Moment, shift: string) => {
  const today = currentTime.format(dateFormat)
  const yesterday = currentTime.clone().subtract(1, 'days').format(dateFormat)

  if (moment(today).isSame(chosenDate)) {
    // unlock from 3:59 to 16:00
    const morningUnlockStart = moment().hour(3).endOf('hour')
    const morningUnlockEnd = moment().hour(16).startOf('hour')
    // unlock from 11:59 to 00:00
    const afternoonUnlockStart = moment().hour(11).endOf('hour')
    const afternoonUnlockEnd = moment().add(1, 'days').hour(0).startOf('hour')
    // unlock from 19:59 to 8:00
    const eveningUnlockStart = moment().hour(19).endOf('hour')
    const eveningUnlockEnd = moment().add(1, 'days').hour(8).startOf('hour')

    if (
      (currentTime.isBetween(morningUnlockStart, morningUnlockEnd) && shift === 'morning') ||
      (currentTime.isBetween(afternoonUnlockStart, afternoonUnlockEnd) && shift === 'evening') ||
      (currentTime.isBetween(eveningUnlockStart, eveningUnlockEnd) && shift === 'night')
    ) {
      return false
    }
  } else if (moment(yesterday).isSame(chosenDate)) {
    // Yesterday's checklist items of night shift will be editable until 7am in the morning of today
    const allowYesterdayEdit = moment(currentTime.clone().subtract(7, 'hours').format(dateFormat)).isSame(yesterday)

    if (allowYesterdayEdit && shift === 'night') {
      return false
    }
  }

  return true
}

type Props = {
  description: string
  shiftStatus: ShiftStatus
  activeStation: Station
  checklistItemId: string
  date: string
  currentTime: moment
}

const ChecklistButtons = (shiftStatus, callback, check, currentHour, date) =>
  Object.entries(shiftStatus).map(([shift, status], key) => {
    return (
      <td key={key} className={css.checkCell}>
        {status !== NOT_AVAILABLE ? (
          <ChecklistButton
            date={date}
            callback={callback}
            check={check}
            isChecked={status === CHECKED}
            timePeriod={shift}
            isLocked={isLocked(date, currentHour, shift)}
          />
        ) : null}
      </td>
    )
  })

@withActiveStation
class ChecklistTaskRow extends Component<Props> {
  check = async (date: string, shift: string, isChecked: boolean, callback: (...args: Array<any>) => any) => {
    const {
      activeStation: { id: stationId },
      checklistItemId,
      shiftStatus: rawShiftStatus,
    } = this.props
    const propsShiftStatus = removeTypename(rawShiftStatus)
    const shiftStatus = {
      ...propsShiftStatus,
      [shift]: !isChecked ? CHECKED : AVAILABLE,
    }

    try {
      await callback({
        refetchQueries: [
          {
            query: fetchDailyChecklist,
            variables: {
              stationId,
              date,
            },
          },
        ],
        awaitRefetchQueries: true,
        variables: {
          stationId,
          checklistItemId,
          shiftStatus,
          date,
        },
      })
      this.setState(shiftStatus)
    } catch (err) {
      // TODO: error handle (sometimes checking an item fails)
    }
  }

  render() {
    const { description, type, date, currentTime } = this.props
    return (
      <Mutation mutation={upsertDailyChecklist}>
        {(upsertDailyChecklist, { data }) => (
          <tr className={css.row}>
            <td className={css.taskName}>{description}</td>
            <td className={cn(css.taskName, css.typeCell)}>
              {type || (
                <em
                  style={{
                    color: 'rgb(169, 169, 169)',
                  }}
                >
                  {i18n.t('checkList.type.NotDefined')}
                </em>
              )}
            </td>
            {ChecklistButtons(
              removeTypename(this.props.shiftStatus),
              upsertDailyChecklist,
              this.check,
              currentTime,
              date,
            )}
          </tr>
        )}
      </Mutation>
    )
  }
}

export default ChecklistTaskRow
